import { isAfter, isSameDay } from 'date-fns';

const dateIsAfterDate = (from, ito) => (
  isAfter(ito, from) || isSameDay(ito, from)
);

export default dateIsAfterDate;
